<template>
  <div>
    <layout :hasBottom="false" :top="true">
      <div slot="head">
        <TopTabbar :hastitle="true" title="活动" />
      </div>
      <div slot="content" class="con">
        <swiper v-if="list.length>0" :options="swiperOption" class="swiperWrap">
          <swiper-slide v-for="(item,index) in list" :key="index" class="swiperItem">
            <img :src="item.img" @click="jump(item.id)" />
            <div class="txt" @click="jump(item.id)">
              <p class="title">{{item.name}}</p>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </layout>
  </div>
</template>
<script>
import { activeList } from "../../api/http.js";
import TopTabbar from "@/components/TopTabbar.vue";
import { getList } from "../../api/http.js";
import layout from "@/components/layout.vue";
import store from "../../store";
export default {
  data() {
    return {
      id: "",
      list: [],
      page: 1,
      isLoading: false,
      loading: false,
      finished: false,
      swiperOption: {
        watchSlidesProgress: true,
        direction: "vertical",
        slidesPerView: "auto",
        centeredSlides: true,
        autoplay: false,
        parallax: true,
        loop: false,
        loopedSlides: 3,
        on: {
          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              let slideProgress = this.slides[i].progress;
              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }

              let translate = "0rem";
              if (slideProgress < 0) {
                translate = (slideProgress * 100) / 102.4 + "rem";
              }
              let translate_txt =
                (-1 *
                  Math.abs(slideProgress) *
                  (document.documentElement.clientHeight - 244)) /
                  102.4 +
                "rem";
              // let translate =
              //   slideProgress *
              //     ((store.state.screenHeight - 44 - 100) / 102.4) +
              //   "rem";
              let zIndex = Math.abs(Math.round(10 * slideProgress));
              slide.find("p").transform("translateY(" + translate_txt + ")");
              slide.transform("translateY(" + translate + ")");
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (
                Math.round(slideProgress) > 1 ||
                Math.round(slideProgress) < -1
              ) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      }
    };
  },
  computed: {
    viewheight() {
      return this.$store.state.screenHeight - 44;
    }
  },
  methods: {
    activeList(page, id, reload) {
      activeList(page, id).then(res => {
        let data = res.data.list.data;
        this.loading = false;
        this.isLoading = false;
        if (res.data.list.current_page >= res.data.list.last_page) {
          this.finished = true;
        }
        if (reload) {
          this.list = [];
        }
        for (let i in data) {
          this.list.push({
            id: data[i].pad_active_id,
            name: data[i].title,
            img: data[i].cover.file_path
          });
        }
      });
    },
    jump(id) {
      this.$router.push({
        path: "/activitydetail",
        query: {
          id: id
        }
      });
    }
  },
  components: {
    TopTabbar,
    layout
  },
  created() {
    this.id = this.$route.query.id || "";
    this.activeList(this.id, this.page, true);
  }
};
</script>
<style lang="scss" scoped>
.con {
  height: 100%;
  .swiperWrap {
    height: 100%;
    .swiperItem {
      position: relative;
      height: 100%;
      overflow: hidden;
      img {
        height: 100%;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }
      .txt {
        position: absolute;
        bottom: 150px;
        left: 20px;
        .title {
          color: #fff;
          margin: 0px;
        }
      }
    }
  }
}
// .body {
//   margin-top: 44px;
//   padding: 10px;
//   .content {
//     width: 100%;
//     .activityWrap {
//       width: 100%;
//       display: flex;
//       flex-wrap: wrap;
//       .activityItem {
//         width: 327px;
//         margin-right: 10px;
//         border-radius: 4px;
//         overflow: hidden;
//         background: #fff;
//         margin-bottom: 10px;
//         .img {
//           width: 327px;
//           height: 327px;
//           overflow: hidden;
//           position: relative;
//           img {
//             position: relative;
//             left: 50%;
//             transform: translateX(-50%);
//             height: 100%;
//           }
//         }
//         .info {
//           text-align: left;
//           font-size: 14px;
//           padding: 15px 17px;
//         }
//       }
//       .activityItem:nth-child(3n) {
//         margin-right: 0px;
//       }
//     }
//   }
// }
</style>


